import { render, staticRenderFns } from "./ResponseType1.vue?vue&type=template&id=99edb7de&scoped=true&"
import script from "./ResponseType1.vue?vue&type=script&lang=js&"
export * from "./ResponseType1.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType1.vue?vue&type=style&index=0&id=99edb7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99edb7de",
  null
  
)

export default component.exports